/*
      ___           ___
     /\  \         /\  \
    /::\  \       /::\  \
   /:/\:\  \     /:/\ \  \
  /::\ \:\  \   _\:\ \ \  \
 /:/\:\ \:\__\ /\ \:\ \ \__\
 \/_|::\/:/  / \:\ \:\ \/__/
    |:|::/  /   \:\ \:\__\
    |:|\/__/     \:\/:/  /
    |:|  |        \::/  /
     \|__|         \/__/

    Developed by Ralph Shippam - 2019.
*/

import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {RSLoadingHTTP} from './rsloading.service';
import { merge, Observable, Subscription, timer } from 'rxjs';
import { debounce, distinctUntilChanged, partition, switchMap, tap } from 'rxjs/operators';
import { trigger, transition, style, animate, state } from '@angular/animations';

@Component({
    selector: 'rs-loading-http',
    templateUrl: 'rsloading.http.component.html',
    styleUrls: ['rsloading.http.scss'],
    exportAs: 'RsloadingHttpComponent',
    animations: [
        trigger('fadeOut', [
            transition(':leave', [
                animate(800, style({ opacity: '0' }))
            ]),
        ])
    ]
})
export class RsloadingHttpComponent implements OnInit, OnDestroy {
    private subscription: Subscription;
    private visibleUntil: number = Date.now();

    @Input() public backgroundColor: string;
    @Input() public debounceDelay = 0; // utilise to skip quick requests
    @Input() public minDuration = 600;
    @Input() public color = 'accent';
    visible: boolean;
    progress: number;

    constructor(private httpLoading: RSLoadingHTTP) {}

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    ngOnInit() {
        this.visible = false;
        this.progress = 10;

        const [showLoader, hideLoader] = partition((h: boolean) => h)(this.httpLoading.pendingRequestsStatus$);

        this.subscription = merge(
            this.httpLoading.pendingRequestsStatus$.pipe(
                tap((value) => this.handleEventProgress(value)),
                switchMap(() => showLoader.pipe(debounce(() => timer(this.debounceDelay))))
            ),
            showLoader.pipe(
                tap((value) => this.handleEventProgress(value)),
                switchMap(() => hideLoader.pipe(debounce(() => this.getHidingTimer())))
            )
        )
        .pipe(distinctUntilChanged())
        .subscribe(h => this.handleSpinnerVisibility(h));
    }

    // TODO: Implement progress tracking and utilise determinate
    private handleEventProgress(started: boolean): void {
        console.log('handleEventProgress::: ' + started);
        this.progress = (started ? 10 : 90);
    }

    private handleSpinnerVisibility(showLoader: boolean): void {
        const now = Date.now();
        if (showLoader && this.visibleUntil <= now) {
            this.visibleUntil = now + this.minDuration;
        }
        this.visible = showLoader;
    }

    private getHidingTimer(): Observable<number> {
        return timer(this.visibleUntil - Date.now());
    }
}
